import { combineReducers } from "redux";
import commonReducer from "./common";
import commonReloadReducer from "./common_reload";
import cartReducer from "./cart";
import orderReducer from "./order";
import settingsReducer from "./settings";
import accountReducer from "./account";

const rootReducer = combineReducers({
  commonReducer,
  commonReloadReducer,
  cartReducer,
  orderReducer,
  settingsReducer,
  accountReducer
});

export default rootReducer;
